import * as types from '../mutation-types';

const state = {

    pageSkip: 0,

    lab: {
        id: -1,
        status: '',
        name: 'storage.main_stream',
        description: '',
        enabled: false,
        metadata: {
            models: []
        }
    },

    labDevices: [],

    user: {

        avatar: {

            source: '',
            url: ''

        },
        email: {

            address: '',
            status: ''
        },
        mobilePhone: {

            number: '',
            status: ''
            
        },
        metadata: {},
        hasPassword: false,
        gender: '',
        firstName: '',
        lastName: '',
        nickName: '',
        id: null,
        locale: '',
        country: ''

    },
    status: '',
    showBeta: false

};

const mutations = {

    [ types.LAB_DEVICE ] ( state, labDevices ) {

        state['labDevices'] = JSON.parse( JSON.stringify( labDevices ));

    },

    [ types.LAB ] ( state, lab ) {

        state['lab'] = JSON.parse( JSON.stringify( lab ));

    },

    [ types.LOGIN ] ( state, user ) {

        for ( let key in state['user'] ) {

            state['user'][ key ] = user[ key ] || 0;

        }

    },

    [ types.LOGOUT ] ( state ) {

        state.user.id = 0;
        state.user.avatar = {

            source: '',
            url: ''

        };

    },

    [ types.PAGESKIP ] ( state ) {

        state.pageSkip++;

    },

    [ types.STATUS_CHANGE ] ( state, status ) {

        state.status = status;

    },

    [ types.SHOW_BETA ] ( state, status ) {

        state.showBeta = status;

    }

};

const getters = {

    lab: state => state.lab,
    labDevices: state => state.labDevices,
    avatarUrl: state => state.user.avatar.url,
    emailAddress: state => state.user.email.address,
    nickName: state => state.user.nickName,
    userId: state => state.user.id,
    pageSkip: state => state.pageSkip,
    country: state => state.user.country

};

export default {

    state,
    mutations,
    getters

};



// WEBPACK FOOTER //
// ./src/store/modules/user.js